import React, { useState } from 'react';
import { Button, Card } from 'react-bootstrap';

import {
  InternalApiAnalysisRunSampleType,
  InternalApiAnalysisRunStatus,
  InternalApiScreeningClearanceRulesAnalysisRun,
} from '../../../api-internal';
import Table from '../../../table/Table';
import FormattedDateTime, { formatDate } from '../../../common/datetime/FormattedDateTime';
import { formatEnumLabel } from '../../../common/helper';
import { useNavigate } from 'react-router';
import { clearanceRuleAnalysisDashboardLink } from '../../../dashboard/dashboardHelpers';

interface Props {
  runs: InternalApiScreeningClearanceRulesAnalysisRun[];
}

export function ScreeningClearanceRulesAnalysisRuns({ runs }: Props) {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const pageSize = 10;

  function getSampleType(run: InternalApiScreeningClearanceRulesAnalysisRun) {
    let result = '';
    if (run.sampleType === InternalApiAnalysisRunSampleType.SET) {
      result += 'Last ' + run.sampleSize + ' alerts';
    } else if (run.sampleType === InternalApiAnalysisRunSampleType.TIMEFRAME) {
      result += 'Alerts between ' + formatDate(run.fromDate as Date) + ' and ' + formatDate(run.toDate as Date);
    } else {
      result += 'Same as previous run';
    }
    if (run.skipFilteredAlerts) {
      result += ' (excluding filtered)';
    }
    return result;
  }

  function navigateToRun(runId?: number) {
    navigate(clearanceRuleAnalysisDashboardLink(runId));
  }

  const renderRuns = () => {
    return runs
      .slice(page * pageSize, page * pageSize + pageSize)
      .map((run: InternalApiScreeningClearanceRulesAnalysisRun) => (
        <tr key={run.id}>
          <td>
            {run.status === InternalApiAnalysisRunStatus.FINISHED && (
              <Button className='btn-white' size='sm' onClick={() => navigateToRun(run.id)}>
                View
              </Button>
            )}
          </td>
          <td>
            <FormattedDateTime date={run.runTime} showTime />
          </td>
          <td>{getSampleType(run)}</td>
          <td className={'text-muted'}>{run.note}</td>
          <td>{formatEnumLabel(run.status as string)}</td>
        </tr>
      ));
  };

  return (
    <Card>
      <Card.Header>
        <h4 className='card-header-title'>Runs</h4>
      </Card.Header>
      <Table
        responsive={false}
        items={runs}
        page={page}
        size={pageSize}
        total={runs.length}
        className='card-table'
        fetchPage={setPage}
        header={() => (
          <tr>
            <th>Details</th>
            <th>Date run</th>
            <th>Sample</th>
            <th>Note</th>
            <th>Status</th>
          </tr>
        )}
        body={renderRuns}
      />
    </Card>
  );
}

export default ScreeningClearanceRulesAnalysisRuns;
